<template>
  <ul class="dropdown-menu account-dropdown">
    <h6>My account</h6>
    <li v-if="isFutureInterestEnabled">
      <menu-item
        path="/my-companies"
        text="Companies"
        @click="hideMenu"
      />
    </li>
    <li>
      <menu-item
        path="/deals/submissions"
        text="Proposals"
        @click="hideMenu"
      />
    </li>
    <li>
      <menu-item
        path="/profile"
        text="Account"
        @click="hideMenu"
      />
    </li>
    <div class="dropdown-footer">
      <li>
        <a @click="handleLogout">Logout</a>
      </li>
    </div>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'
import MenuItem from 'theme/layout/menu/menu-item'

export default {
  name: 'account-dropdown',
  components: {
    MenuItem,
  },
  computed: {
    user() {
      return this.$store.state.user.currentUser
    },
    isFutureInterestEnabled() {
      return this.$store.getters.isFutureInterestEnabled
    },
  },
  methods: {
    ...mapActions({
      logout: 'logout',
      showModal: 'showModal',
    }),
    hideMenu() {
      this.$emit('hide')
    },
    handleLogout() {
      this.$emit('hide')
      this.logout()
    },
    handleHelp() {
      this.$emit('hide')
      this.$intercom.showNewMessage()
    },
  },
}
</script>

<style scoped lang="scss">
.account-dropdown {
  background: #fff;
  padding: $padding-xl;
  display: block;
  position: absolute;
  left: -100px;
  width: 250px;
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
  }
}
.dropdown-footer {
  display: flex;
  justify-content: space-between;
  margin-top: $margin-xl;
  a {
    display: inline-block;
    color: #002560;
    font-size: 12px;
    border-bottom: 1px solid #002560;
    font-weight: 500;
  }
}
</style>
